var exports = {
  "N4": "xcc377c0b--681e3d--feature",
  "RE": "xcc377c0b--681e3d--hoverBackground",
  "nf": "xcc377c0b--681e3d--link",
};

module.exports = exports;
